import { css } from '@microsoft/fast-element';
import { getFontawesomeIconsCss } from '../_config/styles/external/fontawesome-free';
export const foundationIconStyles = (context, definition) => css `
  ${getFontawesomeIconsCss()}
`;
